import { defineStore } from "pinia";
import { type Product as Item } from "@src/api";

export type WidgetName = keyof State;

type WidgetParams = {
  // состояние видимости виджета
  visible: boolean;
  // виджет, на который нужно вернуться при закрытии
  back?: WidgetName | null;
  // флаг, отвечающий за подписку на события главной страницы
  unsubscribe?: boolean;
  // индекс, отвечающий за порядок отображения виджетов
  index?: number;
};

type State = {
  orders: WidgetParams;
  write_random_epc: WidgetParams;
  repair_alarm: WidgetParams;
  label_printing_ut: WidgetParams & { epc: string | null };
  card_item: WidgetParams & { item_id: string | null };
  order_create: WidgetParams;
  search: WidgetParams;
  alarming: WidgetParams;
  check_alarming: WidgetParams;
  write_alarm: WidgetParams;
  check_pairs: WidgetParams;
  check_sales: WidgetParams;
  fitting: WidgetParams;
  zoning: WidgetParams;
  order_card: WidgetParams & { order_id: string | null };
  search_uhf: WidgetParams & { item: Item | null };
  moneymap: WidgetParams;
};

const state_default: State = {
  orders: { visible: false },
  write_random_epc: { visible: false },
  repair_alarm: { visible: false },
  label_printing_ut: { visible: false, epc: null },
  card_item: { visible: false, item_id: null, unsubscribe: false },
  order_create: { visible: false },
  search: { visible: false },
  alarming: { visible: false },
  check_alarming: { visible: false },
  write_alarm: { visible: false },
  check_pairs: { visible: false },
  check_sales: { visible: false },
  fitting: { visible: false },
  zoning: { visible: false },
  order_card: { visible: false, order_id: null, back: null },
  search_uhf: { visible: false, item: null },
  moneymap: { visible: false },
};

export const useWidgetsStore = defineStore("widgets", {
  state: () => state_default,
  actions: {
    open<T extends WidgetName>(name: T, params?: Partial<Omit<State[T], "visible">>) {
      if (params) Object.assign(this[name], params);

      this[name].visible = true;
    },
    close(name: WidgetName) {
      this[name] = {
        ...state_default[name],
        visible: false,
      };
    },
    isOpen(name: WidgetName) {
      return this[name].visible;
    },
    getWidgetStyle(name: WidgetName) {
      return this[name].index ? `z-index: ${this[name].index}` : undefined;
    },
  },
  getters: {
    unsubscribe_main_menu: (state) =>
      Object.keys(state_default).some((key) => state[key].visible && state[key].unsubscribe !== false),
  },
});
